export default function Footer(){

    return (
        <footer className="py-5">
            <p>&copy; haruyam15 🔥</p>
        </footer>
    );

}